import PropTypes from "prop-types"
import React from "react"
import Section from "components/Layout/Section"
import SimpleHeader from "components/Layout/SimpleHeader"
import * as css from "./PillGrid.module.css"

function PillGrid({ label, heading, description, descriptionHtml, pills }) {
  const subtitle = descriptionHtml ? (
    <span dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
  ) : (
    description
  )

  return (
    <Section padding="extraLight">
      <SimpleHeader
        label={label}
        title={heading}
        subtitle={subtitle}
        dash="vertical"
        narrow="both"
      />
      {pills?.length > 0 && (
        <ul className={css.pills}>
          {pills.map((pill, index) => (
            <li key={`pill-${index}`} className={css.pill}>
              <span className={css.dot} aria-hidden="true" />
              {pill}
            </li>
          ))}
        </ul>
      )}
    </Section>
  )
}

PillGrid.propTypes = {
  label: PropTypes.string,
  heading: PropTypes.string.isRequired,
  description: PropTypes.string,
  descriptionHtml: PropTypes.string,
  pills: PropTypes.arrayOf(PropTypes.string),
}

export default PillGrid
